import {REDIRECT } from '@/imports-files/common/common';

export function afterSigninPath(router,  response)
{
  // TODO remove this line 
  // response.type = 'AgencyAdmin';
  if(response.type == "Admin")
  {
    router.push(REDIRECT.admins.dashboard.activities);
  }
  else if(response.type == "ClientUser")
  {
    let new_host = '';
    new_host = window.location.protocol + '//' + response.subdomain + '.' + process.env.NEXT_PUBLIC_INITIAL_HOST
    if(response.sign_in_count == 1 && !process.env.NEXT_PUBLIC_HEARTPACE)
    {
      if(response.role == 'account_owner')
      {
        if(!response.multiple_admin)
          window.location.replace(new_host + REDIRECT.client.success);
        else
          window.location.replace(new_host + REDIRECT.client.quick_setup + response.next_onboarding_step)
      }
      else
      {
        if(['client_user', 'reviewer'].includes(response.role))
          window.location.replace(new_host + REDIRECT.client.quick_setup + response.next_onboarding_step)
        else
          window.location.replace(new_host + REDIRECT.client.quick_setup + response.next_onboarding_step)
      }
    }
    else 
    {
      let redirect_url = localStorage.getItem('redirectUrl')
      if(redirect_url){
        localStorage.removeItem('redirectUrl')
        window.location.replace(redirect_url)
      }
      else{
        window.location.replace(new_host + REDIRECT.client.activities)
      }
    }
  }
  else if(response.agency_user)
  {
    let new_host = '';
    new_host = window.location.protocol + '//' + response.agency_subdomain + '.' + process.env.NEXT_PUBLIC_INITIAL_HOST;
    window.location.replace(new_host + REDIRECT.agency.dashboard.activities)
  }
}